import { useState } from "react";
import { Volume2 } from "lucide-react";

export const PronounceButton = ({ text, tts, className = "" }) => {
  const [playing, setPlaying] = useState(false);

  const speak = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const synth = window.speechSynthesis;
    if (!synth) return;
    synth.cancel();
    const u = new SpeechSynthesisUtterance(text);
    if (tts) u.lang = tts;
    u.rate = 0.85;
    u.onend = () => setPlaying(false);
    u.onerror = () => setPlaying(false);
    synth.speak(u);
    setPlaying(true);
  };

  return (
    <button
      type="button"
      data-testid="pronounce-button"
      onClick={speak}
      title={`Hear "${text}" pronounced`}
      aria-label={`Hear ${text} pronounced`}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-full transition-all shrink-0 ${
        playing ? "bg-pink-600 text-white" : "bg-pink-100 text-pink-600 hover:bg-pink-200"
      } ${className}`}
    >
      <Volume2 className="w-4 h-4" />
    </button>
  );
};

export default PronounceButton;
